// @flow

import { UrlUtils } from '@atlassian/mpac-utils';

import maybeServerErrorRoutes from '../../../../../../common/utils/maybeServerErrorRoutes';
import AddonDiscoveryConfig from '../../../../../records/AddonDiscoveryConfig';
import SolutionsConfig from '../../../../../records/SolutionsConfig';
import createSolutionsRouteHandler from './SolutionsRouteHandler';

import type { AsyncData } from '../../../../../constants/PropTypes';
import type { AMKTRoute } from '../../Routes.types';
import type { CategoriesMetadata } from '../constants/SolutionsPropTypes';

type SolutionsRoutesArgs = {
  addonDiscoveryConfig: AddonDiscoveryConfig,
  solutionsConfig: SolutionsConfig,
  solutionsMetadata: AsyncData<CategoriesMetadata>,
};
// Disabling eslint's react/jsx-key rule for these routes as the way these are consumed are okay with the fact
// that they do not have keys
export default ({
  addonDiscoveryConfig,
  solutionsConfig,
  solutionsMetadata,
}: SolutionsRoutesArgs): AMKTRoute[] =>
  maybeServerErrorRoutes({
    addonDiscoveryConfig,
    isServerError: solutionsMetadata.get('dataError'),
    routes: () =>
      solutionsMetadata.get('data')?.map(solution => ({
        exact: true,
        component: createSolutionsRouteHandler({ solutionKey: solution.key }),
        name: 'categoriesScreen',
        path: UrlUtils.resolveUrlFromTemplateAndParameters({
          template: solutionsConfig.links.solution.href,
          parameters: { category: solution.key },
        }),
      })) ?? [],
    serverErrorPaths: [
      UrlUtils.transformUriTemplateToRoutePath({ template: solutionsConfig.links.solution.href }),
    ],
    statusCode: 502, // 502 because it is an external service causing the error
  });
